import { Link, Navigate } from 'react-router-dom';
import { Typography, List } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';
import Footer from '../../Routes/Footer';
import PublicHeader from '../../Routes/PublicHeader';
import { useNodeInfo } from '../../hooks/use_node_info';

const { Title, Paragraph } = Typography;

const POINTS = [
    'No advertising or analytics cookies',
    'No third-party tracking pixels',
    "We don't sell or rent your data",
    "The only cookie is Keycloak's login-session cookie — required to keep you signed in",
    'Local browser storage holds only your cached profile fields and theme preference',
];

function TrustPage() {
    const { ready, featureTrustPage } = useNodeInfo();
    // Node has the page off (feature_trust_page): send old links/bookmarks to
    // the privacy policy, which covers the same ground in full. Waits for /info
    // so a node with it on never flashes a redirect.
    if (ready && !featureTrustPage) return <Navigate to="/privacy" replace />;

    return (
      <>
        <PublicHeader />
        <div style={{ maxWidth: 720, margin: '0 auto', padding: '32px 16px 64px' }}>
            <Title level={3}>We don't track you</Title>
            <Paragraph type="secondary">
                No ads, no analytics, no third-party trackers — here's exactly what
                that means.
            </Paragraph>

            <List
                dataSource={POINTS}
                renderItem={(item) => (
                    <List.Item>
                        <CheckCircleFilled style={{ color: 'var(--status-success)', marginRight: 8 }} />
                        {item}
                    </List.Item>
                )}
            />

            <Paragraph style={{ marginTop: 24 }}>
                For the full detail on what data we do collect (your entities,
                messages, and account info) and which services process it (Google
                Cloud, Google Gemini, Stripe), see the{' '}
                <Link to="/privacy">Privacy Policy</Link>. The consents you're asked
                to agree to on sign-in are listed on the{' '}
                <Link to="/consents">Consents</Link> page.
            </Paragraph>

            <Paragraph type="secondary">
                This page will grow into a full security &amp; trust overview as we add
                more detail on infrastructure, sub-processors, and data handling.
            </Paragraph>
            <Footer />
        </div>
      </>
    );
}

export default TrustPage;
